import type { AxiosError } from 'axios';

export const getDemoLaunchErrorMessage = (error: unknown): string =>
  (error as AxiosError)?.response?.status === 429
    ? 'Trop de lancements en peu de temps. Merci de réessayer dans une minute.'
    : 'Le lancement de la démo a échoué. Merci de réessayer.';
